import { MutationTree, ActionTree } from 'vuex'
import _get from 'lodash/get'
import router from '../../router'
import instance from '../connection'

class State {
  name: string | null = null
  email: string | null = null
  role: string | null = null
  users: [IUser] | [] = []
  total: number = 0
  pagination = {
    current: 1 as number,
    pageSize: 10 as number,
    total: 0 as number
  }
  sorter = {
    field: '' as string,
    order: '' as string
  }
  organization: string | undefined = undefined
}

const getters = {
  //
}

const actions = <ActionTree<State, any>>{
  async login({ dispatch }, payload: LoginRequest) {
    const result:{token: string} = await instance.post('/login', payload)
    if (result.token) {
      localStorage.setItem('token', result.token);
      instance.defaults.headers.authorization = 'Bearer ' + result.token
      await dispatch('me')
    }
  },
  logout({ commit }) {
    localStorage.removeItem('token')
    instance.defaults.headers.authorization = ''
    commit('updateUser', {})
    commit('setLogin', false)
    if (router.currentRoute.name !== 'Login')
      router.push({name: 'Login'})
  },
  async me({ commit, dispatch }) {
    const result: any = await instance.get('/me')
    if (result) {
      commit('updateUser', result)
      commit('setLogin', true)
      if (result.role === 'admin') {
        dispatch('getOrganizationsList')
      }
    }
  },
  async updateMe({ commit }, user) {
    return commit('updateUser', await instance.put('/me', user))
  },
  async init({ dispatch, rootState }) {
    const token = localStorage.getItem('token')
    if (token && !rootState.isLogin) {
      instance.defaults.headers.authorization = 'Bearer ' + token
      return await dispatch('me')
    }
    else {
      return;
    }
  },
  async getUsers({ commit, state }) {
    let params:any = {
      page: state.pagination.current,
      limit: state.pagination.pageSize,
      sort: state.sorter.field,
      order: state.sorter.order
    }
    if (state.organization) {
      params.org = state.organization
    }
    const users = await instance.get('/user', { params })
    commit('updateUsers', users)
  },
  async activateUser({ dispatch }, {id, active}) {
    await instance.post('/user/' + id + '/activate', {active})
    return await dispatch('getUsers')
  },
  async deleteUser({ dispatch }, id) {
    await instance.delete('/user/' + id)
    return await dispatch('getUsers')
  },
  async updateUser({ dispatch }, user:IUser) {
    await instance.put('/user/' + user.id, user)
    return await dispatch('getUsers')
  },
  async addUser({ dispatch }, user:IUser) {
    await instance.post('/user', user)
    return await dispatch('getUsers')
  },
  async verifyEmail(ctx, {password, token}) {
    return await instance.post('/verifyEmail', {password, token})
  },
  async forgetPassword(ctx, email) {
    return await instance.post('/forgetPassword', {email})
  },
  async resetPassword(ctx, {password, token}) {
    return await instance.post('/resetPassword', {password, token})
  },
}

const mutations = <MutationTree<State>>{
  updateUser(state: State, user) {
    state.name = user.name 
    state.role = user.role
    state.email = user.email
  },
  updateUsers(state, records) {
    state.users = records.data
    state.total = records.total
    state.pagination.total = records.total
  },
  updateUserPagination(state, {current, pageSize, total}) {
    if (current) state.pagination.current = current
    if (pageSize) state.pagination.pageSize = pageSize
    if (total) state.pagination.total = total
  },
  updateUserSorter(state, {field, order}) {
    if (field) state.sorter.field = field
    if (order) state.sorter.order = order
  },
  updateCurrentUserOrg(state, organization) {
    state.organization = organization
  }
}

interface LoginRequest {
  email: string
  password: string
}

interface LoginResponse {
  token: string
}

interface IUser {
  id: string
  email: string
  name: string
  active: string
  lasLogin: string
  created_at: string
}

export default {
  state: new State(),
  getters,
  actions,
  mutations
}